import { WiziQuizUserList } from './WiziQuizUserList';

export default {
    list: WiziQuizUserList,
};
